export default __webpack_public_path__ + "static/media/hexagon-inner-9.684ede98.svg";